import { render, staticRenderFns } from "./LeadActivityFeed.vue?vue&type=template&id=215d23cb&"
import script from "./LeadActivityFeed.vue?vue&type=script&lang=js&"
export * from "./LeadActivityFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports